const education = [
    {
        key:1,
        college:"N.M.A.M Institute of Technology - Nitte",
        year:"2020-2024",
        course:"B.E in Computer Science Engineering",
        marking_scheme:"CGPA: 9.17"
    },
    {
        key:2,
        college:"Poornaprajna P.U College - Udupi",
        year:"2018-2020",
        course:"Science(PCME)",
        marking_scheme:"Percentage: 89.33"
    },
    {
        key:3,
        college:"St Mary's Catholic High School - Fujairah",
        year:"2012-2018",
        course:"Schooling",
        marking_scheme:"Percentage: 88.4"
    },
]

export default education;